import { render, staticRenderFns } from "./HeTongTaiZhang.vue?vue&type=template&id=21b9e7c0&scoped=true&"
import script from "./HeTongTaiZhang.vue?vue&type=script&lang=js&"
export * from "./HeTongTaiZhang.vue?vue&type=script&lang=js&"
import style0 from "./HeTongTaiZhang.vue?vue&type=style&index=0&id=21b9e7c0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9e7c0",
  null
  
)

export default component.exports